import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'py-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RadioComponent {
  @Input()
  showLabel: boolean;

  @Input() ariaLabelledBy?: string;
  @Input() skipLabelElement: boolean = false;
}
